import asset from './asset/store';
import attr from './attr/store';
import defs from './defs/store';
import retrieval from './retrieval/store';

export default {
  namespaced: true,
  modules: { asset, attr, defs, retrieval },
};
